/**
 * openState — 강의 나무의 보기 상태(브라우저 세션). 관리 페이지와 시험지 조립 창 덮개가 같은 열쇠를 쓴다 —
 * 관리 페이지에서 펼쳐 둔 줄이 덮개에서도 펼쳐져 있어야 같은 나무로 읽힌다.
 *
 * 서버에 보내지 않는다: 공유되는 물건 위에 보기 상태를 얹으면 남이 접은 것이 내 화면을 바꾼다(요청서 판 2 §3-3).
 * 저장소가 막혀 있어도(사생활 보호 창 등) 화면은 그대로 선다 — 펼침은 곁들이는 상태다.
 */
const openKey = (sid) => `syllabus-open:${sid}`;
const LAST_KEY = 'syllabus-pick:last';

/** 이 강의에서 펼쳐 둔 줄 번호(문자열) */
export function readOpenIds(sid) {
  try {
    const raw = window.sessionStorage.getItem(openKey(sid));
    const arr = raw ? JSON.parse(raw) : [];
    return new Set(Array.isArray(arr) ? arr.map(String) : []);
  } catch (e) {
    return new Set();
  }
}

export function writeOpenIds(sid, set) {
  try { window.sessionStorage.setItem(openKey(sid), JSON.stringify([...set])); } catch (e) { /* 곁들이는 상태 */ }
}

/**
 * 시험지 조립 창에서 마지막에 쓴 줄 — { syllabusId, nodeId, name }.
 * 창을 다시 열면 초기화가 이겨 강의 선택도 풀리므로(판 2 §4-4), 덮개 머리에 이것 한 줄만 남긴다.
 */
export function readLastPick() {
  try {
    const v = JSON.parse(window.sessionStorage.getItem(LAST_KEY));
    return v && v.syllabusId != null && v.nodeId != null ? v : null;
  } catch (e) {
    return null;
  }
}

export function writeLastPick(v) {
  try { window.sessionStorage.setItem(LAST_KEY, JSON.stringify(v)); } catch (e) { /* 곁들이는 상태 */ }
}
